/** Shrink a chat photo into a clear JPEG, usually well under a few hundred KB. */
const compressChatImage = (file) => new Promise((resolve, reject) => {
  const source = URL.createObjectURL(file);
  const image = new Image();
  image.onload = () => {
    const maxEdge = 1280;
    const scale = Math.min(1, maxEdge / Math.max(image.width, image.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(image.width * scale));
    canvas.height = Math.max(1, Math.round(image.height * scale));
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(source);

    const finish = (quality) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Could not compress image'));
          return;
        }
        if (blob.size > 180 * 1024 && quality > 0.5) {
          finish(Number((quality - 0.08).toFixed(2)));
          return;
        }
        const compressed = new File([blob], 'chat.jpg', { type: 'image/jpeg' });
        resolve({ file: compressed, url: URL.createObjectURL(blob) });
      }, 'image/jpeg', quality);
    };
    finish(0.82);
  };
  image.onerror = () => {
    URL.revokeObjectURL(source);
    reject(new Error('Could not read image'));
  };
  image.src = source;
});

export default compressChatImage;
